import React from 'react';
export function Interview() {
  return <section className="px-4 md:px-8 py-16 md:py-24 border-b border-ink/20" data-id="element-97">
      <div className="max-w-7xl mx-auto" data-id="element-98">
        <div className="flex items-center gap-4 mb-12" data-id="element-99">
          <span className="w-12 h-px bg-vermillion" data-id="element-100" />
          <span className="font-sans text-xs font-bold tracking-kicker text-vermillion uppercase" data-id="element-101">
            ראיון החודש
          </span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-24 items-start" data-id="element-102">
          <div className="order-2 lg:order-1" data-id="element-103">
            <h3 className="font-serif text-4xl md:text-5xl font-black text-ink mb-8" data-id="element-104">
              ״אנחנו בונים ערים, אבל שוכחים לבנות קהילות״
            </h3>

            <div className="font-sans text-lg space-y-8 text-ink-soft" data-id="element-105">
              <div data-id="element-106">
                <p className="font-bold text-ink mb-2" data-id="element-107">
                  קֶרֶן: בעשור האחרון ראינו תנופת בנייה חסרת תקדים. האם אנחנו
                  בונים נכון?
                </p>
                <p data-id="element-108">
                  אדריכלית רותם פלד: אנחנו בונים מהר, אנחנו בונים גבוה, אבל
                  אנחנו לא תמיד בונים נכון. המרחב הציבורי הופך לשיורִי – מה
                  שנשאר אחרי שהקבלן סיים למקסם את אחוזי הבנייה. עיר אמיתית נמדדת
                  במרחבים שבין הבניינים, לא בבניינים עצמם.
                </p>
              </div>

              <div data-id="element-109">
                <p className="font-bold text-ink mb-2" data-id="element-110">
                  קֶרֶן: איך מתקנים את זה?
                </p>
                <p data-id="element-111">
                  זה מתחיל בשינוי תפיסתי. אנחנו צריכים להפסיק לחשוב על נדל״ן
                  ולהתחיל לחשוב על בתי גידול אנושיים. מדרכה רחבה, צל של עץ, ספסל
                  שפונה לרחוב – אלו לא מותרות, אלו תשתיות חברתיות קריטיות בדיוק
                  כמו ביוב וחשמל.
                </p>
              </div>

              <div data-id="element-112">
                <p className="font-bold text-ink mb-2" data-id="element-113">
                  קֶרֶן: מה התפקיד של האדריכל במציאות הזו?
                </p>
                <p data-id="element-114">
                  האדריכל היום חייב להיות קצת סוציולוג, קצת פסיכולוג, והרבה
                  פוליטיקאי. אנחנו צריכים להילחם על זכות הציבור לעיר, גם כשזה
                  מנוגד לאינטרס הכלכלי המיידי.
                </p>
              </div>
            </div>

            <button className="mt-10 px-6 py-3 border border-ink text-ink font-sans font-medium hover:bg-ink hover:text-paper transition-colors" data-id="element-115">
              קרא את הראיון המלא
            </button>
          </div>

          <div className="order-1 lg:order-2 relative" data-id="element-116">
            <div className="aspect-square w-full relative overflow-hidden bg-ink" data-id="element-117">
              <div className="absolute inset-0 bg-vermillion/20 mix-blend-multiply z-10" data-id="element-118" />
              <img src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?q=80&w=800&auto=format&fit=crop" alt="Portrait of Architect" className="w-full h-full object-cover grayscale contrast-125" data-id="element-119" />
            </div>
            <div className="absolute -bottom-6 -right-6 w-48 h-48 border border-vermillion pointer-events-none hidden md:block" data-id="element-120" />
          </div>
        </div>
      </div>
    </section>;
}